import type { Route } from '@angular/router';
import { ForecastResolver } from '@backoffice/forecast/domain';
import { CanDeactivateGuard } from '@clean-code/shared/components/ui-can-deactivate';

export const forecastScaleRoute: Route = {
  path: 'forecastScalesEdit',
  children: [
    {
      path: ':id',
      loadComponent: () =>
        import('./forecast-scales-edit/forecast-scales-edit.component').then(
          (mod) => mod.ForecastScalesEditComponent,
        ),
      resolve: {
        entity: ForecastResolver,
      },
      data: { translate: 'forecast' },
      canDeactivate: [CanDeactivateGuard],
    },
    {
      path: ':id/:source/:sourceId',
      loadComponent: () =>
        import('./forecast-scales-edit/forecast-scales-edit.component').then(
          (mod) => mod.ForecastScalesEditComponent,
        ),
      resolve: {
        entity: ForecastResolver,
      },
      data: { translate: 'forecast' },
      canDeactivate: [CanDeactivateGuard],
    },
  ],
};
